/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function ThumbsDown({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M3 9a1.6 1.6 0 0 1-1.6-1.6V2.9A1.6 1.6 0 0 1 3 1.3h7.875a2.6 2.6 0 0 1 2.502 1.895l.984 3.492a2.6 2.6 0 0 1-2.502 3.305H9.822V11.9a2.6 2.6 0 0 1-2.6 2.6h-.428a.6.6 0 0 1-.573-.424L4.659 9H3Zm1.4-1.2V2.5H3a.4.4 0 0 0-.4.4v4.5c0 .22.18.4.4.4h1.4Zm1.2.18 1.638 5.32a1.4 1.4 0 0 0 1.384-1.4V9.392a.6.6 0 0 1 .6-.6h2.637a1.4 1.4 0 0 0 1.347-1.78l-.984-3.492a1.4 1.4 0 0 0-1.347-1.02H5.6v5.48Z" clipRule="evenodd" /></svg>;
}
;